import { Check, Error, LoopOutlined, Schedule, StopCircle } from '@mui/icons-material';
import { WorkflowActionStatus } from 'gql/index';
import { useMemo } from 'react';

export const WorkflowActionStatusChip = (props: { actionStatus: WorkflowActionStatus }) => {
  const icon = useMemo<React.ReactNode>(() => {
    switch (props.actionStatus) {
      case WorkflowActionStatus.Completed:
        return <Check color='success' />;
      case WorkflowActionStatus.InProgress:
        return <LoopOutlined color='info' />;
      case WorkflowActionStatus.NotStarted:
        return <Schedule color='warning' />;
      case WorkflowActionStatus.Error:
        return <Error color='error' />;
      case WorkflowActionStatus.Stopped:
        return <StopCircle color='warning' />;
    }
  }, [props.actionStatus]);

  return icon;

};